import appStore from 'store';
import api from './api';
import { STATUS_TYPE, ONLINE_STATUS } from './constants';
const store = {
  namespaced: true,
  state: {
    pagination: {
      page: 1,
      size: 25
    },
    merchants: [],
    totalCount: 0
  },
  getters: {
    merchantList: state => {
      return state.merchants.map(item => ({
        ...item,
        __status: STATUS_TYPE[item.status],
        __onlineStatus: ONLINE_STATUS[item.isOnline]
      }));
    }
  },
  mutations: {
    setMerchantList(state, payload) {
      state.merchants = payload.list.concat();
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    reqMerchantList({ commit }, query) {
      api.reqMerchants(query).then(({ data }) => {
        commit('setMerchantList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    addMerchant(context, data) {
      return api.addMerchant(data);
    },
    removeMerchant(context, data) {
      return api.removeMerchant(data);
    }
  }
};

appStore.registerModule('merchant', store);
